import type { DownloaderFontSchemaType, DownloaderSchemaType } from '@vedalib/editor/lib/brand'
import type { DownloaderElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import type { FCDemoType } from '../../elements.types'
import Element from './DownloaderElement'

const DEMO_VALUE: DownloaderElementValue = { file: null, label: t('elements.downloader.label') }

const DownloaderDemo: FCDemoType<DownloaderSchemaType, DownloaderFontSchemaType> = ({
  styles,
  fonts,
  feedback,
}) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.downloader.type}-demo`,
        type: CONFIG_ELEMENTS.downloader.type,
        value: DEMO_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default DownloaderDemo
